<template>
  <main-content>
    <div>
      <topuserchart></topuserchart>
    </div>
  </main-content>
</template>

<script>
import topUserChart from './components/top-users-chart.vue'
import mainContent from '@/components/main-content'

export default {
  name: "TopUser",
  components: {
    'topuserchart': topUserChart,
    'main-content': mainContent,

  }
}
</script>

<style scoped>

</style>